module.exports = __webpack_public_path__ + "static/alpine-fleet-skin-8a8bc6f2b894f83642bf68d16b206c1e.jpg";